module.exports = __webpack_public_path__ + "img/w1_5.c15c6366.png";